import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {LayoutManagerService} from '../../layout-manager.service';
import {TranslateService} from '@ngx-translate/core';
import {Software, SoftwaresList} from '../../api/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {timer} from 'rxjs';

declare  var jQuery:  any;

@Component({
  selector: 'app-store-content',
  templateUrl: './store-content.component.html',
  styleUrls: ['./store-content.component.css']
})
export class StoreContentComponent implements OnInit,AfterViewInit {

  @Input()softwares: SoftwaresList

  selectedSoftware: string

  viewSoftware = undefined

  software: Software

  testString = ['Qualità','Efficienza', 'Affidabilità', 'Attualità']
  countAnim = 0;
  animState = 0;
  tmpString = '';
  tmpCount = 0;
  countBreak = 0;

  constructor(
    private layoutManager: LayoutManagerService,
    private translateService: TranslateService,
    private router: Router,
    private route:ActivatedRoute
  ) {
    //console.log(layoutManager.innerWidth)
    window.scroll(0,0)
    this.charAnimation()
  }

  basetos(src:string):string{
    return atob(src)
  }

  getSoftwareByName(softwares: SoftwaresList): Software {
    for (let soft of softwares.softwares) {
      if (soft.software_name == this.viewSoftware)
        return soft
    }
  }

  ngOnInit() {
    this.viewSoftware = this.route.snapshot.paramMap.get("software")
    if(this.viewSoftware != undefined)
      this.software = this.getSoftwareByName(this.softwares)
  }

  charAnimation() {
    const source = timer(2000, 70);
    const abc = source.subscribe(val => {
      if(this.countBreak == 0) {
        switch (this.animState) {
          case 0:
            if (this.tmpString.length == this.testString[this.countAnim].length) {
              this.animState = 1;
              this.countBreak = 15;
            } else {
              this.countBreak = 2;
              this.tmpString += this.testString[this.countAnim].charAt(this.tmpCount++)
            }
            break;
          case 1:
            if (this.tmpString.length == 0) {
              this.countAnim++;
              if (this.countAnim == this.testString.length)
                this.countAnim = 0
              this.animState = 0;
            } else {
              this.tmpString = this.tmpString.substr(0, this.tmpCount--)
            }
          default:
            break;
        }
      }else
        this.countBreak--;

    });
  }

  ngAfterViewInit(){

    ( function ( $ ) {
      "use strict";
      var carousel = $( ".carousel" );
      function doAnimations( elems ) {
        console.log('loadpage2');
        //Cache the animationend event in a variable
        var animEndEv = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elems.each( function ( ) {
          var $this = $( this ),
            $animationType = $this.data( 'animation' );
          $this.addClass( $animationType ).one( animEndEv, function ( ) {
            $this.removeClass( $animationType );
          } );
        } );
      }

      //Variables on page load
      var $firstAnimatingElems = carousel.find( '.carousel-item:first' ).find( "[data-animation ^= 'animated']" );
      //Initialize carousel
      carousel.carousel( );
      //Animate captions in first slide on page load
      doAnimations( $firstAnimatingElems );
      console.log('firstload');
      //Other slides to be animated on carousel slide event
      carousel.on( 'slide.bs.carousel', function ( e ) {
        var $animatingElems = $( e.relatedTarget ).find( "[data-animation ^= 'animated']" );
        doAnimations( $animatingElems );
      } );
    } )( jQuery );


    // CODE 2 for static-slider 2
  }

  noSelectItem() {
    this.selectedSoftware = '';
  }

  selectItem(item) {
    this.selectedSoftware = item;
  }

  viewItem(item) {
    this.router.navigateByUrl('/store/'+item)
  }

}
